module.exports = __webpack_public_path__ + "img/icon_map_8_on_010.5ace59d7.png";